import { filterSearchResults } from "./filterSearchResults";

export function filterSportsFromSearchResults(data, search) {
    let sports = [];

    if (data == null) {
        return sports;
    }

    const results = filterSearchResults(data, search, 'MATCH', function(match) {
        return match.desc;
    });

    const sportById = {};
    results.forEach(function(match) {
        if (sportById[match.sportRef] == null) {
            const sport = {
                id: match.sportRef,
                desc: match.sportDesc,
                tournaments: [],
                tournamentById: {},
            };
            sports.push(sport);
            sportById[match.sportRef] = sport;
        }
        const sport = sportById[match.sportRef];
        if (sport.tournamentById[match.tournamentRef] == null) {
            const tournament = {
                id: match.tournamentRef,
                desc: match.tournamentDesc,
                events: [],
            };
            sport.tournaments.push(tournament);
            sport.tournamentById[match.tournamentRef] = tournament;
        }
        const tournament = sport.tournamentById[match.tournamentRef];
        tournament.events.push(match);
    });
    return sports;
}
